import mixx from '../../../../mixin/mixin.js'
import $ from 'jquery'
import AutoNumeric from 'autonumeric'



export default {
  mixins: [mixx],
  name: 'tventas',
  data() {
    return {
      loading: false,
      loading_f: false,

      linkR: '',
      cupon: {
        titulo: '',
        cuotas: '',
        precio: 0,
        email: '',
        opc1: '',
        opc2: '',
        opc3: '',
        linkOk: '',
        linkErr: ''

      },
      lcuotas: []
    }
  },

  mounted: function () {
    this.cuotash()
    let nm = new AutoNumeric('#mnt', {
      currencySymbol: '$ ',
      decimalCharacter: ',',
      digitGroupSeparator: '.'
    })
  },

  methods: {

    copiarLink () {
      navigator.clipboard.writeText(this.linkR)
      this.showNotification({
        msj: 'Link copiado.',
        bg: 'bg-green'
      })
    },

    crearNuevo () {
      this.linkR = ''
      this.cupon = {
        titulo: '',
        cuotas: '',
        precio: 0,
        email: '',
        opc1: '',
        opc2: '',
        opc3: '',
        linkOk: '',
        linkErr: ''
      }
      $('#box1').css('display', 'block')
      $('#box2').css('display', 'none')
      $('#mnt').val('')
    },
    cuotash () {
      this.loading = true
      this.$http
        .post('/SERVER/scd/ecash/', {
          'a': 'cuotash'
        }, {
          withCredentials: true
        })
        .then(response => {
          if (response.data.status === 1) {
            this.lcuotas = response.data.data
            for (let i = 0; i < this.lcuotas.length; i++) {
              if (this.lcuotas[i].cuotas === 1) {
                this.cupon.cuotas = this.lcuotas[i].cuotas
                break
              }
            }
          }
          this.loading = false
        })
    },
    crear () {
      this.cupon.precio = $('#mnt').val().replace('$ ', '').replace('.', '').replace(',', '.')
      if (this.cupon.titulo != '' && this.cupon.cuotas != '' && this.cupon.precio != 0 && this.cupon.email != '') {
        this.loading = true
        this.linkR = ''
        this.$http
          .post('/SERVER/scd/ecash/', {
            'a': 'crear',
            'data': this.cupon
          }, {
            withCredentials: true
          })
          .then(response => {
            if (response.data.status === 3333) {
              this.showNotification({
                msj: 'Servicio no habilitado',
                bg: 'bg-red'
              })
            } else {
              if (response.data.data.status === 1) {
                this.linkR = response.data.data.url
                $('#box1').css('display', 'none')
                $('#box2').css('display', 'block')
              } else {
                this.showNotification({
                  msj: 'Error al crear cupon: ' + response.data.data.err,
                  bg: 'bg-red'
                })
              }
            }
            this.loading = false
          })
      } else {
        this.showNotification({
          msj: 'Complete todos los campos requeridos.',
          bg: 'bg-yellow'
        })
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/ecash/crear/tventas/index.js